import { ThunkAction } from "redux-thunk";
import { IAppState, ApiRequest } from "../../Common";
import { endpoints } from "../Constants/endpoints";
import ResponseHandler from "../../App/ResponseHandler";
import { StatusCode } from "../../App/Enums/StatusCode";

export enum TopicSubscriptionActionType {
  TOPIC_SUBSCRIPTION_LOADED = "TOPIC_SUBSCRIPTION_LOADED",
  TOPIC_SUBSCRIPTION_SET_LOADING = "TOPIC_SUBSCRIPTION_SET_LOADING",
  TOPIC_SUBSCRIPTION_SET_ERRORED = "TOPIC_SUBSCRIPTION_SET_ERRORED",
  TOPIC_SUBSCRIPTION_UNLOAD = "TOPIC_SUBSCRIPTION_UNLOAD"
}

export const setTopicSubscriptionStatusErrored = (
  topicCode: string,
  errorCode: number,
  errorDescription: string,
  errorResult: string
) => {
  return {
    type: TopicSubscriptionActionType.TOPIC_SUBSCRIPTION_SET_ERRORED,
    payload: {
      topicCode,
      errorCode,
      errorDescription,
      errorResult
    }
  };
};

export const setTopicSubscriptionStatusLoading = (topicCode: string) => {
  return {
    type: TopicSubscriptionActionType.TOPIC_SUBSCRIPTION_SET_LOADING,
    payload: {
      topicCode
    }
  };
};

export const unloadTopicSubscriptionStatus = (topicCode: string) => {
  return {
    type: TopicSubscriptionActionType.TOPIC_SUBSCRIPTION_UNLOAD,
    payload: {
      topicCode
    }
  };
};

export const getTopicSubscriptionStatus = (
  topicCode: string
): ThunkAction<void, IAppState, {}, any> => dispatch => {
  ApiRequest.fromPath(endpoints.subscriptions.status(topicCode))
    .withAuthHeader()
    .get()
    .then(response => {
      ResponseHandler.handle(
        response,
        result => {
          dispatch({
            type: TopicSubscriptionActionType.TOPIC_SUBSCRIPTION_LOADED,
            payload: { topicCode, ...result.payload }
          });
        },
        result => {
          dispatch(
            setTopicSubscriptionStatusErrored(
              topicCode,
              response.status,
              result.error.message,
              "Failed to load subscription status"
            )
          );
        },
        () => {
          dispatch(
            setTopicSubscriptionStatusErrored(
              topicCode,
              response.status,
              "An unknown error has occured",
              "Failed to load subscription status"
            )
          );
        }
      );
    })
    .catch(() => {
      dispatch(
        setTopicSubscriptionStatusErrored(
          topicCode,
          StatusCode.Status503ServiceUnavailable,
          "Unable to contact server",
          "Failed to load subscription status"
        )
      );
    });
};
